import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Sales Footer CTA Component
 * Consistent sales CTA that appears above the footer on all pages
 * Matches the homepage "Ready to Transform Your Content?" design
 *
 * @param {boolean} hideTryItFree - Whether to hide the Try It Free button (true for /free pages)
 */
const SalesFooterCTA = ({ hideTryItFree = false }) => {
  return (
    <>
      {/* Sales CTA Section */}
      <section style={{
        padding: '100px 0',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        color: 'white',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Subtle background pattern */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} />
        <Container style={{ position: 'relative', zIndex: 1 }}>
          <h2 style={{
            fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
            fontWeight: '700',
            marginBottom: '1rem'
          }}>
            Ready to Transform Your Content?
          </h2>
          <p style={{
            marginBottom: '2.5rem',
            opacity: '0.85',
            fontSize: '1.125rem',
            maxWidth: '500px',
            margin: '0 auto 2.5rem'
          }}>
            Start creating multi-platform content in seconds.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            {!hideTryItFree && (
              <Link
                to="/free"
                className="btn btn-lg"
                style={{
                  fontWeight: '600',
                  padding: '0.875rem 2.5rem',
                  background: 'white',
                  color: '#1a1a2e',
                  borderRadius: '8px',
                  border: 'none'
                }}
              >
                Try It Free
              </Link>
            )}
            <Link
              to="/contact"
              className="btn btn-lg"
              style={{
                fontWeight: '600',
                padding: '0.875rem 2.5rem',
                background: hideTryItFree ? 'white' : 'transparent',
                color: hideTryItFree ? '#1a1a2e' : 'white',
                borderRadius: '8px',
                border: hideTryItFree ? 'none' : '2px solid rgba(255,255,255,0.4)'
              }}
            >
              Contact Sales
            </Link>
          </div>
        </Container>
      </section>

      {/* Subtle separator line between sales footer and main footer */}
      <div style={{
        height: '1px',
        background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.08) 20%, rgba(255,255,255,0.08) 80%, transparent 100%)'
      }} />
    </>
  );
};

export default SalesFooterCTA;
